<div class="container">
  <div class="body">
    <div class="logo">
      <img src="assets/images/logoHD-Modal.svg" class="logo" alt="logoHD" />
    </div>

    <div class="text">
      <span> Por favor completa el resumen de consulta de tu paciente. </span>
    </div>

    <!-- @if ( !modalData ) { -->
    <div class="button">
      <button
        class="btn btn-primary"
        mat-raised-button
        color="primary"
        (click)="goToResume()"
      >
        <span class="text"> Ir a resumen de consulta </span>
      </button>
    </div>
    <!-- } -->
  </div>
</div>
